<template>
  <div>
    <!-- Background banner disabled per Ofir's redesign request — page now leads with the search widget directly. -->
    <!-- <Banner :imageList="bannerImages" :showSlider="showTopSlider" type="home" :hideMoble="true" /> -->
    <search-tab />

    <!--
      Productions grid — curated deals from whap4u's /api/public/productions
      feed. Hidden for agencies that opted out of marketing content
      (hideMarketingDeals, isHeverAgency), same gate the other marketing blocks
      below use.
    -->
    <!-- Productions grid — always shown per Ofir 2026-08-15. Do NOT gate on
         hideMarketingDeals; on agent.flyingcarpet.co.il that flag is always
         true (isAgentSite) so gating would kill the grid entirely. -->
    <ProductionsGrid
      :items="productionsItems"
      :loading="productionsLoading"
    />

    <ContentLoading type="banner" v-if="!loaded"/>
    <h1 class="flying-advertisement text-center mb-0" v-if="!hideMarketingDeals && !isHeverAgency">
      {{ isEmalonMode ? $t("home.emalon-advertisement") : $t("home.flying-advertisement")}}
    </h1>
    <p v-else class="flying-advertisement"></p>
    <TopBanner :topBanner="topBanner" v-if="loaded && showTopBanner && topBanner.length>0 && !hideMarketingDeals"/>

    <div v-if="loaded && !dealData && !hideMarketingDeals" class="loading-message">{{ $t('home.deal-loading-message') }}</div>
    <Lesiurpackages :promotionData="dealData" v-if="loaded && dealData && !!dealData.length && !hideMarketingDeals && !hideSlider" />
    <ContentLoading v-if="loaded && !dealData && !hideMarketingDeals" type="deal" />
    <Lesiurtabs
      :dealType="dealType"
      :dealData="dealData"
      :banner="middleBanner"
      :bannerHref="middleBannerHref"
      :showBanner="showMiddleBanner"
      v-if="loaded && !!dealData && !!middleBanner && !hideMarketingDeals"
    />
    <Footer page="home" v-if="!hideFooter"/>

  </div>
</template>

<script>
import TemplateHome from './TemplateHome';
import ProductionsGrid from '@/components/productions/ProductionsGrid';

export default {
  name: 'Home0',
  mixins: [TemplateHome],
  components: {
    // Banner removed per redesign; keep import commented for easy revert.
    // Banner: () => import('@/components/content/Banner'),
    Lesiurpackages: () => import('@/components/home/Lesiurpackages'),
    Lesiurtabs: () => import('@/components/home/lesiurtabs/LesiurtabsTheme0'),
    Footer: () => import('@/components/content/footer/FooterTheme0'),
    ContentLoading: () => import('@/components/atoms/ContentLoading'),
    TopBanner: () => import('@/components/home/topBanner/TopBannerTheme0'),
    SearchTab: () => import('@/components/search/searchTabs/SearchTabsTheme0'),
    ProductionsGrid,
  },
  computed: {
    productionsItems() {
      return this.$store.getters.GET_PRODUCTIONS || [];
    },
    productionsLoading() {
      // Show skeletons only on the very first load — after that, refreshes are
      // silent so the visible grid doesn't flicker to gray.
      return this.$store.getters.GET_PRODUCTIONS_LOADING
        && !this.$store.getters.GET_PRODUCTIONS;
    },
  },
  mounted() {
    // Fire-and-forget — the grid renders empty (nothing) until data arrives,
    // and hides itself on failure by keeping the previous cache.
    this.$store.dispatch('FETCH_PRODUCTIONS');
  },
};
</script>

<style scoped>
  .flying-advertisement {
    font-family: "ploni";
    font-weight: bold;
    font-size: 3rem;
    text-transform: capitalize;
    margin-top: 70px;
  }

@media (max-width: 767px) {
  .flying-advertisement {
    font-size: 2rem;
    padding: 5px;
    margin-top: 0px;
  }
}
</style>
